export default __webpack_public_path__ + "static/media/ETEF-6-7.4652efc5.pdf";